module.exports = __webpack_public_path__ + "assets/img/b78efba6481ae5300b3eeaf222a4b413.svg";